import isEqual from 'lodash/isEqual';
import { createProviderStore2 } from '@/common/store/createProviderStore';
import { createWithEqualityFn } from 'zustand/traditional';
import { Girdle, PageRowData, ServiceRule } from '../views/api';
import { webCurrency } from '@/common/const';
// import { Model } from '@/request/index';

// type PageData = Model['GET/rest/o/ecom/customer/item/info']['responses']['data'];

type VideoStatus = {
    currentTime: number;
    seekableDuration: number;
    seek: number;
    target: number;
    playableDuration: number;
    muted: boolean;
    paused: boolean;
    naturalSize: {
        width: number;
        height: number;
        orientation: 'landscape' | 'portrait';
    };
};

// {
//     DEFAULT, // 用户没有地址时圣保罗
//     USER, // 用户的默认地址或者临时地址
//     GPS, // 根据gps获取的地址
//     IP, // 根据ip获取的地址
// }
export type AddressType = 'DEFAULT' | 'USER' | 'GPS' | 'IP';

// 商详页跨组件获取信息
export const createDetailPageState = () =>
    createWithEqualityFn(
        (set: any) => ({
            itemId: 0 as number,
            // outSide Coupon Data
            couponData: {} as any,
            store_id: Date.now(),
            immediateAvailableQuantity: 1, // 动态库存 伴随勾选规格而变化
            displayCommissionRate: '',
            // 达人佣金信息
            commissionInfo: {
                remainMilliseconds: 0,
                displayCommissionRate: '', // 佣金率
                // commission: '',
                displayCommissions: '',
                commissionSubsidy: 0, // 佣金补贴
                displayCommissionSubsidy: '',
                totalCommission: 0, // 总佣金（商家佣金+佣金补贴）
                displayTotalCommission: '',
            },
            // 关于券的信息 后面要改版 变成不容商详主接口里边返回 变成单独接口
            discountCoupon: [],
            // 首屏数据搬到Store
            pageRawData: {} as PageRowData,
            // 統一腰封信息
            bigMarketingBanner: false as unknown as Girdle,
            // B 端商详价格、腰封、秒杀的信息
            businessItemDetail: {},
            pageLoading: true,
            pageError: false,
            detailImageurls: [],
            purchaseQuantity: 1,
            specImageIndex: -1, // 规格图index
            swiperImageIndex: 0, // 商品图index（在swiper组件使用的index）
            setPurchaseQuantity: val => set(() => ({ purchaseQuantity: val })),
            currentSku: {} as PageRowData['skus'][number],
            setCurrentSku: val => set(() => ({ currentSku: val })),
            fetchData: (() => undefined) as (options?: { init?: boolean; noSke?: boolean }) => Promise<void>,
            setFetchData: (val: () => void) => set(() => ({ fetchData: val })),
            addressInfo: {} as {
                postalCode?: any;
                id?: string | number;
                addressId?: number;
                countryName?: string;
                provinceName?: string;
                cityName?: string;
                districtName?: string;
                streetName?: string;
            },
            setAddressInfo: val => set(() => ({ addressInfo: val })),
            showVideoPhoto: true,
            setShowVideoPhoto: (val: boolean) => set(() => ({ showVideoPhoto: val })),
            bottomAreaTipConfigLength: 0,
            // 商详页返回弹窗引导加购
            alertVisible: {
                specPupoup: false, // 多规格弹窗是否弹出
                visible: false,
                isOverTime: false,
                isClickedCart: false,
                isClickedBuy: false,
                isOverLastSpecTime: false,
                isOverLastOpenTime: false,
            },
            itemOnShelf: false,
            distributePlanOpen: false,
            merchant: {
                promoterType: 0,
            },
            setAlertVisible: val => set(() => ({ alertVisible: val })),
            productReco: {
                list: [],
                cursor: 0,
                hasNext: true,
                recoFirstLoading: true,
            },
            delivery: {
                logisticsType: 1,
                expressFeeType: 3,
                expressFee: -1,
                displayExpressFee: `${webCurrency}0,01`,
            } as Partial<ServiceRule>,
            addressType: 'DEFAULT' as AddressType,
            // 天降弹窗是否展示，用于多个弹窗的联动展示判断
            couponDialogState: '' as '' /* 初始值 */ | 'Openning' /* 弹窗打开中 */ | 'Closed' /* 弹窗被关闭 */ | 'NotNeed' /* 不需要弹窗 */,
            // 提单页动态运费券商详页利益点透出 弹窗是否展示，用于多个弹窗的联动展示判断
            couponDialog2State: '' as '' /* 初始值 */ | 'Openning' /* 弹窗打开中 */ | 'Closed' /* 弹窗被关闭 */ | 'NotNeed' /* 不需要弹窗 */,
            // 关闭弹窗2
            onCloseCoupon2Dialog() {
                set({ couponDialog2State: 'Closed' });
            },
            // 点击去购买按钮，从业务组件中set进来
            onBuyNow: null as (
                button_type?,
                options?: {
                    // 那先加个新字段is_shipping_coupon吧，如果是点了这一期优惠券上报1，否则为0
                    is_shipping_coupon: 1 | 0;
                }
            ) => void,
            // 刷新优惠些列表，从业务组件中set进来
            refreshCouponList: null as () => void,
            galleryImgList: [],
            showGalleryType: [],
            galleryTotal: 0,
            showVideo: false,
            showMoreCouponPopVisible: false,
            showMoreCouponPop: () => undefined,
            showSampleButton: false, // 是否在b端商详页展示1元申样, 展示逻辑由接口控制
            hadShowCartBtnTip: false, // 是否展示过购物车底部按钮的文案提示
            videoStatus: {
                currentTime: 0,
                seekableDuration: 0,
                seek: 0,
                target: 0,
                playableDuration: 0,
                naturalSize: {
                    width: 0,
                    height: 0,
                    orientation: null as 'landscape' | 'portrait',
                },
                muted: true,
                paused: true,
            } as VideoStatus,
            setVideoStatus: (val: Partial<VideoStatus>) => {
                set(pre => ({
                    videoStatus: {
                        ...pre.videoStatus,
                        ...val,
                    },
                }));
            },
        }),
        isEqual
    );

export type IDetailPageStata = ReturnType<typeof createDetailPageState>;

export type IDetailPageState = ReturnType<ReturnType<typeof createDetailPageState>['getState']>;

export const { ProviderComponent: DetailPageDataProvider, useStore: useDetailPageStore } =
    createProviderStore2<IDetailPageStata>(createDetailPageState);
